import React from "react";
import { setOvertimeAllowed } from "./slice";
import { useDispatch, useSelector } from "react-redux";
import { payRateTypeObj } from "../../helpers/data";

const OvertimeAllowed = (props) => {
  const isOvertimeAllowed = useSelector((store) => store.jobOpportunity.isOvertimeAllowed);
  const payRateType = useSelector((store) => store.jobOpportunity.payRateType);
  const dispatch = useDispatch();

  const overtimeChangeHandler = ({radioName}) => {
    if(radioName === "YES"){
      dispatch(setOvertimeAllowed(true));
    } else {
      dispatch(setOvertimeAllowed(false));
    }
   
  };

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 class="card-title">Overtime Allowed <span className="required">*</span></h3>
      </div>
      <div className="card-body d-flex align-items-center">
        <div
          style={{ padding: "0.5rem", cursor: "pointer", position: "relative" }}
          className="col border rounded-3  "
        >
          <div className="d-flex gap-2 align-items-center ">
            <div className="me-4">Overtime Allowed</div>
            <div
           
                class="form-check p-4 m-0"
              >
                <input
                //  disabled={( +payRateType === payRateTypeObj?.systemCal)}
                    onChange={() =>
                      overtimeChangeHandler({radioName: "YES" })
                    }
                  class="form-check-input"
                  type="radio"
                  name={`overtimeAllowedYes`}
                  id={`overtimeAllowedYes`}
                  checked={(isOvertimeAllowed) === true && true}
                />
                <label  style={{cursor:'pointer'}} htmlFor={"overtimeAllowedYes"} class="form-check-label">Yes</label>
              </div>
              <div
               
                class="form-check  p-4 m-0"
              >
                <input
                 onChange={() =>
                  overtimeChangeHandler({ radioName: "NO" })
                }
                  disabled={( +payRateType === payRateTypeObj?.manualCal)}
                  class="form-check-input"
                  type="radio"
                  name={`overtimeAllowedNo`}
                  id={`overtimeAllowedNo`}
                  checked={isOvertimeAllowed === false && true}
                />
                <label  style={{cursor:'pointer'}} htmlFor={"overtimeAllowedNo"} class="form-check-label">No</label>
              </div>
          </div>
          <div style={{ position: "absolute", top: "100%" }}>
            {props.errors &&
              props.errors["isOvertimeAllowed"]?.map((error) => (
                <div className="invalid-input">{error}</div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OvertimeAllowed;
